module.exports = __webpack_public_path__ + "img/Mobile-Homepage.83fa649.png";